import React from 'react';

class Survey extends React.Component {
    render() {
        return (
            <div className = 'dms-body' >
                {this.props.children}
            </div>
        )
    }
};
export default Survey;


// WEBPACK FOOTER //
// ./src/routes/survey/index.js